module.exports = __webpack_public_path__ + "src/img/point.8161b823.svg";